import React, {useEffect, useState} from 'react';
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";

const AllocatePolicy = (props) => {


    const [policyHolder, setPolicyHolder] = useState({});


    const openAccidentForm = () => {
        const policyHolderId = policyHolder.id;
        localStorage.setItem('policyHolderId', JSON.stringify(policyHolderId));
        props.history.push('/allocate-accident');
    }

    const openComprehensiveForm = () => {
        const policyHolderId = policyHolder.id;
        localStorage.setItem('policyHolderId', JSON.stringify(policyHolderId));
        props.history.push('/allocate-comprehensive');
    }

    const openFuneralForm = () => {
        const policyHolderId = policyHolder.id;
        localStorage.setItem('policyHolderId', JSON.stringify(policyHolderId));
        props.history.push('/allocate-funeral');
    }

    const openSavingsForm = () => {
        const policyHolderId = policyHolder.id;
        localStorage.setItem('policyHolderId', JSON.stringify(policyHolderId));
        props.history.push('/allocate-savings');
    }

    const openIlifaForm = () => {
        const policyHolderId = policyHolder.id;
        localStorage.setItem('policyHolderId', JSON.stringify(policyHolderId));
        props.history.push('/allocate-ilifa');
    }

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        const PH = JSON.parse(localStorage.getItem('policyHolder'));
        const policyHolder = PH.policyHolder;
        setPolicyHolder(policyHolder);
        console.log("PolicyHolder: ", policyHolder.id);
    }, []);

    return (
     <div>
         <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
         <div id="main-content" className="main-panel ps-container ps-theme-default">
           <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
             <div className="content">
                 <div className="container-fluid">
                     <ul className="breadcrumb">
                         ALLOCATE POLICY TO &nbsp;<span
                         className="text-uppercase text-primary">{policyHolder.title}&nbsp;{policyHolder.first_name}&nbsp;{policyHolder.last_name}</span>
                     </ul>
                     <div className="row mt-5 mb-5">
                         <div className="mt-5 col-lg-12">
                             <div className="card">
                                 {/* Main Content*/}
                                 <div className="card-header">
                                     <h4 className="card-title">
                                         Choose Product
                                     </h4>
                                 </div>
                                 <div className="card-body">
                                     <div className="row ml-4 mt-5 mb-5">
                                         <div className="col-6 container-fluid">
                                             <div className="row">
                                                 <div className="col-lg-3 col-md-3 col-sm-6 col-xs-6">
                                                     <button onClick={openAccidentForm}
                                                             className="btn btn-primary p-3">Allocate Accident Policy
                                                     </button>
                                                 </div>
                                                 <div className="col-lg-3 col-md-3 col-sm-6 col-xs-6">
                                                     <button onClick={openComprehensiveForm}
                                                             className="btn btn-primary p-3">Allocate Comprehensive
                                                         Policy
                                                     </button>
                                                 </div>
                                                 <div className="col-lg-3 col-md-3 col-sm-6 col-xs-6">
                                                     <button onClick={openFuneralForm}
                                                             className="btn btn-primary p-3">Allocate Funeral Policy
                                                     </button>
                                                 </div>
                                                 <div className="col-lg-3 col-md-3 col-sm-6 col-xs-6">

                                                     <button onClick={openSavingsForm}
                                                             className="btn btn-primary p-3">Allocate Savings Policy
                                                     </button>

                                                 </div>
                                                 <div className="col-lg-3 col-md-3 col-sm-6 col-xs-6">
                                                     <button onClick={openIlifaForm}
                                                             className="btn btn-primary p-3">Allocate Pfuma / Inotho
                                                     </button>
                                                 </div>
                                             </div>

                                         </div>

                                     </div>
                                 </div>


                             </div>
                         </div>
                     </div>
                 </div>
             </div>
         </div>
     </div>
    )
}

export default AllocatePolicy;
